import React from "react";
import { makeStyles } from "@mui/styles";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { Button } from "@mui/material";
import { DATE_FORMAT } from "utils/helper";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    display: "flex",
  },

  roundedButtons: {
    borderRadius: 17,
    margin: 1.6,
    paddingTop: 5,
    paddingBottom: 5,
    color: "#33CCCC",
  },
  buttonGroup: {
    textAlign: "end",
  },
  selectedColor: {
    backgroundColor: "#33CCCC",
    color: "white",
  },
}));

const DateTabs = ({
  duration,
  setDuration,
  dateRange,
  onDateChange,
  setDateRange,
}) => {
  const classes = useStyles();
  const ButtonArray = ["WEEK", "WORK WEEK", "DAY"];

  const GetDateRange = () => {
    const { startDate, endDate } = dateRange;
    if (startDate && endDate) {
      let text = "";
      const newStartDate = dayjs(startDate).format(DATE_FORMAT);
      const newEndDate = dayjs(endDate).format(DATE_FORMAT);

      if (duration === "DAY") {
        text = newStartDate;
      } else {
        text = `${newStartDate} - ${newEndDate}`;
      }
      return <span>{text}</span>;
    }
    return null;
  };

  const handleDateChange = (date) => {
    let start, end;

    if (duration === "WEEK") {
      start = dayjs(date).startOf("week");
      end = start.add(6, "day");
    } else if (duration === "WORK WEEK") {
      start = dayjs(date).startOf("week").add(1, "day"); // Monday
      end = start.add(4, "day"); // Friday
    } else {
      start = dayjs(date);
      end = start;
    }

    setDateRange({
      startDate: start.toDate(),
      endDate: end.toDate(),
    });
  };

  return (
    <div className={classes.root}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <DesktopDatePicker
          slotProps={{
            textField: {
              variant: "standard",
              InputProps: {
                disableUnderline: true, // Removes the underline
              },
            },
          }}
          format={DATE_FORMAT}
          value={dayjs(dateRange.startDate)}
          onChange={handleDateChange}
          maxDate={dayjs()}
          sx={{ marginRight: 10, width: "5px" }}
        />
        <ArrowBackIosIcon
          fontSize="small"
          onClick={() => onDateChange("subtract")}
        />
        <GetDateRange />
        <ArrowForwardIosIcon
          fontSize="small"
          onClick={() => onDateChange("add")}
        />
      </div>
      <div>
        {ButtonArray.map((buttonText) => (
          <Button
            key={buttonText}
            variant={duration === buttonText ? "contained" : null}
            className={
              duration === buttonText
                ? [classes.roundedButtons, classes.selectedColor]
                : classes.roundedButtons
            }
            onClick={() => setDuration(buttonText)}
          >
            {buttonText}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default DateTabs;
